//LMIT-603
import React, { Component } from 'react';
import './css/landing-page.css';
import Welcome from './welcome.js';
import Login from './login.js';

class LandingPage extends Component {

	/*constructor(props){
		super(props);
		//console.log("LandingPage");
	}*/
	componentDidMount() {
	}

	componentWillUnmount() {
	}
	
	doLogin(){
		//console.log("LandingPage doLogin()");
		this.props.ctx.setState( {isLoggedIn : true} );
	}
	
	doLogout(){
		//console.log("LandingPage doLogout()");
		this.props.ctx.setState( {isLoggedIn : false} );
	}
	
	unscheduledOutage(){
		this.loginPage.unscheduledOutage();
	}
	
	scheduledOutage(){
		this.welcomePage.scheduledOutage();
	}	
	
	render() {
		return (
			<div id="landing-page">
				<Welcome ref={ welcomePage => this.welcomePage = welcomePage}/>
				<Login ctx={this} ref={ loginPage => this.loginPage = loginPage}/>
			</div>
		);
	}
}
export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/landing-page.js